import addAward from "./addAward.ts";
import addRatingsRow from "./addRatingsRow.ts";
import addRelatives from "./addRelatives.ts";
import addStatsRow from "./addStatsRow.ts";
import addToFreeAgents from "./addToFreeAgents.ts";
import augmentPartialPlayer from "./augmentPartialPlayer.ts";
import bonus from "./bonus.ts";
import checkJerseyNumberRetirement from "./checkJerseyNumberRetirement.ts";
import checkStatisticalFeat from "./checkStatisticalFeat.ts";
import compositeRating from "./compositeRating.ts";
import contractSeasonsRemaining from "./contractSeasonsRemaining.ts";
import develop from "./develop.ts";
import developSeason from "./developSeason.ts";
import fuzzRating from "./fuzzRating.ts";
import fuzzOvrs from "./fuzzOvrs.ts";
import genContract from "./genContract.ts";
import genFuzz from "./genFuzz.ts";
import genJerseyNumber from "./genJerseyNumber.ts";
import genMoodTraits from "./genMoodTraits.ts";
import genRandomFreeAgent from "./genRandomFreeAgent.ts";
import genWeight from "./genWeight.ts";
import generate from "./generate.ts";
import getLeaders from "../player/getLeaders.ts";
import getPlayerFakeAge from "./getPlayerFakeAge.ts";
import heightToRating from "./heightToRating.ts";
import injury from "./injury.ts";
import killOne from "./killOne.ts";
import limitRating from "./limitRating.ts";
import madeHof from "./madeHof.ts";
import moodInfo from "./moodInfo.ts";
import moodInfos from "./moodInfos.ts";
import name from "./name.ts";
import ovr from "./ovr.ts";
import pos from "./pos.ts";
import release from "./release.ts";
import remove from "./remove.ts";
import retire from "./retire.ts";
import setContract from "./setContract.ts";
import setJerseyNumber from "./setJerseyNumber.ts";
import sign from "./sign.ts";
import shouldRetire from "./shouldRetire.ts";
import skills from "./skills.ts";
import stats from "./stats.ts";
import updateOvrMeanStd from "./updateOvrMeanStd.ts";
import updateValues from "./updateValues.ts";
import value from "./value.ts";
import valueCombineOvrPot from "./valueCombineOvrPot.ts";

export default {
	addAward,
	addRatingsRow,
	addRelatives,
	addStatsRow,
	addToFreeAgents,
	augmentPartialPlayer,
	bonus,
	checkJerseyNumberRetirement,
	checkStatisticalFeat,
	compositeRating,
	contractSeasonsRemaining,
	develop,
	developSeason,
	fuzzRating,
	fuzzOvrs,
	genContract,
	genFuzz,
	genJerseyNumber,
	genRandomFreeAgent,
	genMoodTraits,
	genWeight,
	generate,
	getLeaders,
	getPlayerFakeAge,
	heightToRating,
	injury,
	killOne,
	limitRating,
	madeHof,
	moodInfo,
	moodInfos,
	name,
	ovr,
	pos,
	release,
	remove,
	retire,
	sign,
	setContract,
	setJerseyNumber,
	shouldRetire,
	skills,
	stats,
	updateOvrMeanStd,
	updateValues,
	value,
	valueCombineOvrPot,
};
